<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="في-اليوم-التالي">
<h1><span dir="rtl">في اليوم التالي</span></h1>
<p><span dir="rtl">في مزرعةِ السّيد مالك بعد أن أخَذ الجميع أماكنهم وعمَّ الهدوء في البيت، نهض عليّ وتَرَك فِراشه الدّافئ وتسلَّل إلى خارج المنزل بعد أن ارتدى معطفه وصادَف حياة.</span></p>
<p><span dir="rtl">علي: ألم تنامي؟</span></p>
<p><span dir="rtl">- أرى أنَّكَ أيضًا لم تستَطع النَّوم.</span></p>
<p><span dir="rtl">- لا أعتقد بأنَّني سأهنأ بنومٍ بعد اليوم.</span></p>
<p><span dir="rtl">- لماذا؟ قالت حياة ذلكَ وظلَّت تنظر في عينيهِ مُنتظرةً جوابهُ.</span></p>
<p><span dir="rtl">- بسببكِ.</span></p>
<p><span dir="rtl">- بسببي أنا!</span></p>
<p><span dir="rtl">- نعم.</span></p>
<p><span dir="rtl">- كيف؟</span></p>
<p><span dir="rtl">- بسبب النَّافذة المفتوحة، لقد دخل الهواءُ البارد إلى رئتي وأعتقدُ بأنَّني على وشكِ أن أمرض.</span></p>
<p><span dir="rtl">- أنا آسفةٌ.</span></p>
<p><span dir="rtl">ابتسم عليّ ثم أخرج عُلْبة السّجائر من جَيْب المِعطف وأخرج منها سيجارةً ووضعها في فمه وحاول إشعالها بالولّاعة الَّتي أهدته إياها علياء.</span></p>
<p><span dir="rtl">توقَّفَ عن إشعالها للحظاتٍ بعد أن لَمَح أَحْرُف اسميهما منقوشَيْن على الولّاعة، ثمَّ أشعل السّيجارة وسحَبَ نفسًا عميقًا وأخرج دُخانًا كثيفًا ضاعت ملامِحه خلفه.</span></p>
<p><span dir="rtl">أخذَت "حياة" تُبعثِر الدّخان في الهواء بيدها، وعندما انتَهت سحبت السّيجارة من فَمه ورَمَتْها على الأرض.</span></p>
<p><span dir="rtl">استغربَ من تصرُّفها.</span></p>
<p><span dir="rtl">- لن أمنعك عن التَّدخين لأنّني لا أملكُ الحقَّ في ذلك، لكنَّني لن أسمح لك أن تُدخِّن وتتَّهمني بأنَّني سبب مرضك.</span></p>
<p><span dir="rtl">- لا تُحاولي، سأمرض بسببك.</span></p>
<p><span dir="rtl">- ولِمَ لا يكون بسبب التَّدخين؟</span></p>
<p><span dir="rtl">- بسببكِ.</span></p>
<p><span dir="rtl">- مُصِرٌّ!</span></p>
<p><span dir="rtl">- نعم.</span></p>
<p><span dir="rtl">- لن أدعك تدخّن إذًا.</span></p>
<p><span dir="rtl">- وإن فعلْتُها.</span></p>
<p><span dir="rtl">-سأطفئ كلَّ سيجارةٍ تُشْعلها.</span></p>
<p><span dir="rtl">- لن تفعلي!</span></p>
<p><span dir="rtl">- سأفعل.</span></p>
<p><span dir="rtl">- أنتِ متوتّرة.</span></p>
<p><span dir="rtl">- لا!</span></p>
<p><span dir="rtl">- إذًا أنتِ خائفة.</span></p>
<p><span dir="rtl">- لماذا تقول هذا؟</span></p>
<p><span dir="rtl">- واضحٌ من تصرّفاتك.</span></p>
<p><span dir="rtl">- تصرّفاتي!</span></p>
<p><span dir="rtl">ابتسم، فردَّت عليه:</span></p>
<p><span dir="rtl">- لا، لستُ متوتِّرةً أو خائفةً، بل مرعوبة.</span></p>
<p><span dir="rtl">- لماذا تركتِ كلّ شيء ورجعتِ إذًا؟</span></p>
<p><span dir="rtl">صمتتْ. فابتسمَ من جديد.</span></p>
<p><span dir="rtl">حياة: أفهمتَ كلَّ هذا من تصرّفاتي؟ وكأنَّني لا أعرف أنَّ العمّ أخبرك بكلِّ شيءٍ.</span></p>
<p><span dir="rtl">- لم يُخبِرني شيئًا سوى أنَّك رجعتِ دون عِلْم والِدَيْك، أريدُ أن أسمع الأسباب مِنك.</span></p>
<p><span dir="rtl">- لم أرغَب بالدِّراسة في إسطنبول أبدًا، كنتُ دائمًا أحلمُ بالدّراسة هنا مع صديقاتي في بلدي لكنَّ والدتي كانت تُصرّ على ذهابي إلى إسطنبول والدِّراسة هناك مِثْل بقيَّة بنات العائلة.</span></p>
<p><span dir="rtl">- هل لدَينا بناتٌ غيرك في العائلة؟</span></p>
<p><span dir="rtl">- أقصد القسم التركيّ.</span></p>
<p><span dir="rtl">- كان يجبُ عليكِ أن تُدافعي عن أحلامك وألّا تسمحي لأحدٍ بفرض رغباته عليك مُنذ البداية.</span></p>
<p><span dir="rtl">- لكنّها أمّي يا عليّ، لا أستطيع إحزانها.</span></p>
<p><span dir="rtl">- لكنَّك فعلتِ، أعني لو كنتِ واضحةً معها منذ البدايةِ ومتمسكّةً برأيك لما اضطررتِ إلى فِعل كلّ هذا.</span></p>
<p><span dir="rtl">- برأيي هذا أفضل.</span></p>
<p><span dir="rtl">- كيف؟</span></p>
<p><span dir="rtl">- بعدَ رُجوعي بتلك الطّريقة ستقتنع بأنَّه لا فائدة من إرسالي إلى هُناك، لأنّني سأهرُب من جديد.</span></p>
<p><span dir="rtl">- لا أدري لماذا ترفضين الدّراسة في إسطنبول وأنتِ تعرفين أنّ فكرة الدّراسة في الخارج حُلمٌ بالنّسبة للكثيرين، وهي فُرصةٌ للتعرُّف على ثقافةٍ مُختلفةٍ.</span></p>
<p><span dir="rtl">- إذا كان هذا قصدكَ فاعلم بأنَّ لا أحد يُجاريني في معرفة ثقافة الأتراك.</span></p>
<p><span dir="rtl">- كيف؟</span></p>
<p><span dir="rtl">- نسيتَ بهذه السُّرعة أنَّ السيّدة فخريّة من أصولٍ تركيّة.</span></p>
<p><span dir="rtl">- نسيتُ!</span></p>
<p><span dir="rtl">انتظرتْ لحظاتٍ وقالت:</span></p>
<p><span dir="rtl">- لم تفكّر في زيارَتنا منذ أن غادرتَ، حتّى عندما كنتَ هنا لم تكن تزورنا إلّا في المُناسبات، وأحيانًا كثيرةً كنت تفوِّت حتّى المُناسبات، عندما كنتُ صغيرةً كنتُ أسمعُ بكَ ولا أراكَ.</span></p>
<p><span dir="rtl">- أنا نادمٌ جدًّا يا حياة.</span></p>
<p><span dir="rtl">- لم يَفُت الأوان على ذلك، يمكنك أن تبدأ من جديد.</span></p>
<p><span dir="rtl">- صعب!</span></p>
<p><span dir="rtl">- ليس صعبًا أبدًا، والدي يحبّك كثيرًا أنتَ ابنُ أخته الوحيد.</span></p>
<p><span dir="rtl">ابتسمَ وهزّ رأسه: نعم.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch015.vue?2caa0035